import React, { useMemo } from 'react'

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@barracuda-internal/bds-core'

import { useFormatMessage } from 'lib/localization'

import {
  useDeleteUserDialog,
  UseEditUserDialogLogicProps
} from 'components/pages/users/usersList/deleteUserDialog/useDeleteUserDialogLogic'

const BASE_I18N_KEY = 'ess.dialog.delete_user'

export type EditUserDialogProps = UseEditUserDialogLogicProps

function DeleteUserDialog({ onClose, userIds, ...rest }: EditUserDialogProps) {
  const formatDialogText = useFormatMessage(BASE_I18N_KEY)
  const [state, eventHandlers] = useDeleteUserDialog({ onClose, userIds })

  return useMemo(
    () => (
      <Dialog fullWidth maxWidth="sm" open {...rest}>
        {state.dialogError && <Alert severity="error">{formatDialogText(state.dialogError)}</Alert>}
        <DialogTitle disableTypography>
          <Typography variant="h6">
            {formatDialogText(userIds.length > 1 ? 'titles' : 'title', {
              user: userIds.join(', '),
              count: userIds.length,
              b: (txt: string) => <b>{txt}</b>
            })}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container direction="row" alignItems="center">
            <Typography data-testid="description">{formatDialogText('delete_confirmation')}</Typography>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={eventHandlers.onCancel} color="primary" disabled={state.deleteInProgress}>
            {formatDialogText('cancel')}
          </Button>
          <Button
            variant="contained"
            onClick={eventHandlers.onDelete}
            color="primary"
            isLoading={state.deleteInProgress}
          >
            {formatDialogText('confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    ),
    [formatDialogText, state, eventHandlers, rest, userIds]
  )
}

export default DeleteUserDialog
